import {
  Profile,
  LoginError,
  PasswordError,
  SsoError,
  UserError,
} from '@/interfaces';
import { MainState, AppNotification } from './state';
import { getStoreAccessors } from 'typesafe-vuex';
import { State } from '../state';

export const mutations = {
  setToken(state: MainState, payload: string) {
    state.token = payload;
  },
  setLoggedIn(state: MainState, payload: boolean) {
    state.isLoggedIn = payload;
  },
  setLoginError(state: MainState, payload: LoginError) {
    state.loginError = payload;
  },
  clearLoginError(state: MainState) {
    state.loginError = null;
  },
  setSsoError(state: MainState, payload: SsoError) {
    state.ssoError = payload;
  },
  clearSsoError(state: MainState) {
    state.ssoError = null;
  },
  setProfile(state: MainState, payload: Profile) {
    state.profile = payload;
  },
  setProfileError(state: MainState, payload: UserError) {
    state.profileError = payload;
  },
  clearProfileError(state: MainState) {
    state.profileError = null;
  },
  setPasswordError(state: MainState, payload: PasswordError) {
    state.passwordError = payload;
  },
  clearPasswordError(state: MainState) {
    state.passwordError = null;
  },
  setDashboardShowDrawer(state: MainState, payload: boolean) {
    state.dashboardShowDrawer = payload;
  },
  addNotification(state: MainState, payload: AppNotification) {
    state.notifications.push(payload);
  },
  removeNotification(state: MainState, payload: AppNotification) {
    state.notifications = state.notifications.filter(
      (notification) => notification !== payload,
    );
  },
};

const { commit } = getStoreAccessors<MainState | any, State>('');

export const commitSetDashboardShowDrawer = commit(
  mutations.setDashboardShowDrawer,
);
export const commitSetLoggedIn = commit(mutations.setLoggedIn);
export const commitSetLoginError = commit(mutations.setLoginError);
export const commitClearLoginError = commit(mutations.clearLoginError);
export const commitSetSsoError = commit(mutations.setSsoError);
export const commitClearSsoError = commit(mutations.clearSsoError);
export const commitSetToken = commit(mutations.setToken);
export const commitSetProfile = commit(mutations.setProfile);
export const commitSetProfileError = commit(mutations.setProfileError);
export const commitClearProfileError = commit(mutations.clearProfileError);
export const commitSetPasswordError = commit(mutations.setPasswordError);
export const commitClearPasswordError = commit(mutations.clearPasswordError);
export const commitAddNotification = commit(mutations.addNotification);
export const commitRemoveNotification = commit(mutations.removeNotification);
